<template>
<div class="row mt-5">
  <div class="col-xl-5" v-if="checkForPermission(add_timezone_permission)">
    <timezone-form button_text="Add Timezone" @timezoneAction="addTimezone"/>
  </div>
  <div class="col-xl-1"></div>
  <div class="col-xl-6">
    <TableLoading v-if="timezones.page === 0"/>
    <data-table v-else :columns="columns" :rows="timezones.objects">
      <template v-slot:actions="slotProps" v-if="checkForPermission(edit_timezone_permission)">
        <b-button v-b-modal.edit-zone variant="success" size="sm" class="py-1 text-white" @click="selectZone(slotProps.row)">
          Edit
        </b-button>
      </template>
    </data-table>
    <b-modal
        id="edit-zone"
        centered
        size="lg"
        hide-footer
        hide-header
        title-class="font-18">
      <div class="p-2">
        <h3>Edit TimeZone</h3>
        <timezone-form button_text="Edit Zone" :selected_zone="selected_zone" @timezoneAction="editTimezone"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-zone')">Close</b-button>
      </div>
    </b-modal>
  </div>
</div>
</template>

<script>
import TimezoneForm from "@/components/settings/timezone-form";
import DataTable from "@/components/data-table";
import {ALL_TIMEZONES} from "@/gql/system-settings";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";
export default {
name: "timezone-component",
  components: {TableLoading, DataTable, TimezoneForm},
  data(){
    return{
      searchTerm: '',
      selected_zone: {},
      add_timezone_permission: permissions.add_timezone_permission,
      edit_timezone_permission: permissions.edit_timezone_permission,
      columns: [
        {
          field: 'timezoneName',
          label: 'Name'
        },
        {
          field: 'timezoneStartTime',
          label: 'Start Time'
        },
        {
          field: 'timezoneEndTime',
          label: 'End Time'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
      timezones: {
        page: 0,
        objects: []
      }
    }
  },
  apollo: {
    timezones: {
      query: ALL_TIMEZONES,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    }
  },
  methods: {
    ... mapActions({
      addTimeZoneFn: 'settings/addNewTimezone',
      updateTimeZoneFn: 'settings/updateTimezone'
    }),
    async addTimezone(data){
      await this.addTimeZoneFn(data).then(resp => {
        if(resp.publicId){
          this.updateTimeZone()
          successToast('New zone added successfully')
        }

      })
    },
    async editTimezone(data){
      data.id = this.selected_zone.publicId
      await this.updateTimeZoneFn(data).then(resp => {
        if(resp.publicId) {
          this.updateTimeZone()
          successToast(`${resp.timezoneName} updated successfully`)
        }
      })
    },
    selectZone(row){
      this.selected_zone = row
    },
    updateTimeZone(){
      this.$apollo.queries.timezones.refetch()
    }
  }
}
</script>

<style scoped>

</style>
